
import Page from './Page';
import withRouterParams from '../withRouterParams';
import request from '../request';
import swal from 'sweetalert';
import { hideLoading, showLoading } from '../loading';
import { Button } from '@mui/material';

class _VerifyEmail extends Page {

   verify = async () => {

      const { ref_code } = this.props.params;


      try {
         
         showLoading('Verifying email');

         await request.post('/api/auth/email-verification', { ref_code });

         swal('Success', 'Email verified', 'success');
         window.App.redirect('/login');

      } catch (err) {
         swal('Error', err, 'error');
      } finally {
         hideLoading();
      }
   }

   _render() {
      return <div className='page-height flex justify-center items-center'>
         <div className='text-xl text-gray-500 text-center p-8 border-b-[1px]'>
            <p>
               Click the button below to<br/>
               verify your email.
            </p>

            <Button onClick={this.verify} variant='contained' className='mt-4 rounded-full' size='small'>
               Verify Email
            </Button>
         </div>
      </div>
   }
}


const VerifyEmail = withRouterParams(_VerifyEmail);

export default VerifyEmail;